import React from 'react';
import styled from 'styled-components';
import closedIcon from '~images/Kiinni_palvelu.svg';
import openIcon from '~images/Auki_palvelu.svg';

import CheckboxField from '~fields/CheckboxField';
import { primaryColor } from '~theme';
import { Gap } from '~ui-kit';

const linkifyPhone = (string, number) => {
  if (!number || string.search(number) === -1) return <span>{string}</span>;
  let left = '';
  let right = '';
  [left, right] = string.split(number);
  return (
    <span>
      <span>{left}</span>
      <a href={`tel:${number}`}>{` ${number} `}</a>
      <span>{right}</span>
    </span>
  );
};

const Closed = ({ timeInfo, children }) => (
  <div>
    <div>
      <b>{timeInfo.headingClosed || 'Palvelu on kiinni tällä hetkellä'}</b>
    </div>
    <OpenHoursString>
      {linkifyPhone(timeInfo.openHoursString, timeInfo.phone)}
    </OpenHoursString>
    <InfoClosed>
      {linkifyPhone(timeInfo.infoServiceClosed, timeInfo.phone)}
    </InfoClosed>
    {children}
  </div>
);

const Open = ({ timeInfo }) => (
  <div>
    <div>
      <b>{timeInfo.headingOpen || 'Palvelu on auki tällä hetkellä'}</b>
    </div>
    <OpenHoursString>
      {linkifyPhone(timeInfo.openHoursString, timeInfo.phone)}
    </OpenHoursString>
  </div>
);

const renderInner = (timeInfo, urgency) => {
  if (!timeInfo) return <div>Aukioloajat puuttuvat</div>;
  switch (timeInfo.openStatus) {
    case 'OPEN':
      return <Open timeInfo={timeInfo} />;
    case 'CLOSED_WITH_RESERVE_AND_PHONE':
    case 'CLOSED_WITH_RESERVE':
      return (
        <Closed timeInfo={timeInfo}>
          {urgency.canBeUrgent && (
            <>
              <Gap height="8px" />
              <CheckboxField name="isUrgent" label="Kiireellinen" />
              {urgency.isUrgent && (
                <UrgentText>
                  {linkifyPhone(timeInfo.infoCheckedUrgent, timeInfo.phone)}
                </UrgentText>
              )}
            </>
          )}
        </Closed>
      );
    case 'CLOSED_WITH_PHONE':
    case 'CLOSED':
      return <Closed timeInfo={timeInfo} />;
    case 'UNKNOWN':
      return <div>Tuntemattomat aukioloajat</div>;
    default:
      return <div />;
  }
};

const defaultUrgency = { canBeUrgent: false, isUrgent: false };

const OpenHours = ({ timeInfo, urgency = defaultUrgency }) => {
  const isOpen = timeInfo && timeInfo.open === 'OPEN';
  const isClosed = timeInfo && timeInfo.open === 'CLOSED';

  return (
    <Container>
      {isOpen && <Icon src={openIcon} alt="open" />}
      {isClosed && <Icon src={closedIcon} alt="closed" />}
      {renderInner(timeInfo, urgency)}
    </Container>
  );
};

const Icon = styled.img`
  height: 24px;
  margin-right: 16px;
`;

const UrgentText = styled.span`
  margin-top: 16px;
  display: flex;
  margin-bottom: 5px;
  align-items: center;
  margin-left: 8px;
  font-size: 16px;
`;

const OpenHoursString = styled.div`
  font-size: 16px;
`;

const InfoClosed = styled.div`
  margin-top: 8px;
`;

const Container = styled.div`
  background-color: #f2f2f2;
  padding: 8px 16px;
  color: ${primaryColor};
  display: flex;
  max-width: var(--field-width);

  & > :nth-child(2) {
    margin-top: 4px;
    line-height: 1.5;
  }
`;

export default OpenHours;
